module.exports = __webpack_public_path__ + "img/level_1.ae76d6a2.svg";